<div class="container">
  <!-- Header usando componente shared -->
  <app-page-header
    title="Desbloquear Usuario"
    subtitle="Reestablece el acceso de usuarios bloqueados"
    icon="user">
  </app-page-header>

  <div class="form-alert form-alert--error" *ngIf="showAlertError">
    <i class="form-alert-icon">⚠</i>
    <span>{{ errorMessage }}</span>
  </div>
  <div class="form-alert form-alert--success" *ngIf="showAlerSuccess">
    <i class="form-alert-icon">✓</i>
    <span>{{ message1ForSuccesAlert }}</span>
  </div>
  <section class="unlock-users">
    <div class="form-container">
      <form class="form-wrapper" #unblockUserForm="ngForm" (ngSubmit)="onSubmit(unblockUserForm)">
        <div class="form-content">
          <div class="form-row form-row--single">
            <div class="form-group">
              <label for="nit-input" class="form-label form-label--required">NIT</label>
              <input id="nit-input" class="form-input" type="text" placeholder="Ingresa NIT" [(ngModel)]="nitInput"
                name="nitInput" #nitModel="ngModel" required
                [ngClass]="{'form-input--error': nitModel.invalid && nitModel.touched}">
              <div *ngIf="nitModel.invalid && nitModel.touched" class="form-error-message">
                <i class="form-error-icon">&#9888;</i>
                <span class="form-error-text">Este campo es requerido!</span>
              </div>
            </div>
          </div>
          <div class="form-row form-row--single">
            <div class="form-group">
              <label for="username" class="form-label form-label--required">Usuario</label>
              <input id="username" class="form-input" type="text" placeholder="Ingresa Usuario" [(ngModel)]="username"
                name="usernameInput" #usernameModel="ngModel" aria-label="Ingresa nombre" required
                [ngClass]="{'form-input--error': usernameModel.invalid && usernameModel.touched}">
              <div *ngIf="usernameModel.invalid && usernameModel.touched" class="form-error-message">
                <i class="form-error-icon">&#9888;</i>
                <span class="form-error-text">Este campo es requerido!</span>
              </div>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button type="button" class="form-btn form-btn--cancel" (click)="cancel(unblockUserForm)"
            [ngClass]="{'is-active': unblockUserForm.valid}">Cancelar</button>
          <button type="submit" class="form-btn form-btn--submit" [ngClass]="{'is-valid': unblockUserForm.valid}"
            [disabled]="unblockUserForm.invalid">Desbloquear</button>
        </div>
      </form>
    </div>
  </section>
  <app-confirmation-modal [isVisible]="isModalVisible" [confirmationText]="'¿Seguro que deseas realizar esta acción?'" [confirmButtonText]="'Desbloquear'"
    (confirmed)="onConfirm(unblockUserForm)" (canceled)="onCancel()"></app-confirmation-modal>
</div>